import { render, staticRenderFns } from "./caririskRaporuAlcvadeRenderer.vue?vue&type=template&id=4b22b76b&"
import script from "./caririskRaporuAlcvadeRenderer.vue?vue&type=script&lang=js&"
export * from "./caririskRaporuAlcvadeRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports